import React from "react";
import { Router, Location, Redirect } from "@reach/router";

import Home from "./pages/home";
import ScrollToTopBtn from "./menu/ScrollToTop";
import Header from "./menu/header";
import MarketPage from "./pages/marketPage";
import ViewItem from "./pages/viewItem";
import ManageRecord from "./pages/manageRecord";
import LicenseDetails from "./pages/licenseDetails";
import Manage from "./pages/manage";
import Wallet from "./pages/wallet";
import Attestation from "./pages/attestation";
import Create from "./pages/create";
import Decode from "./pages/decode";
import Contact from "./pages/contact";
import Uploader from "./pages/ipfsUploader";
import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  :root {
    scroll-behavior: unset;
  }
`;

export const ScrollTop = ({ children, location }) => {
  React.useEffect(() => window.scrollTo(0, 0), [location]);
  return children;
};

const PosedRouter = ({ children }) => (
  <Location>
    {({ location }) => (
      <div id="routerhang">
        <div key={location.key}>
          <Router location={location}>{children}</Router>
        </div>
      </div>
    )}
  </Location>
);

const app = () => (
  <div className="wraper">
    <GlobalStyles />
    <Header />
    <PosedRouter>
      <ScrollTop path="/">
        <Home exact path="/">
          <Redirect to="/home" />
        </Home>
        <MarketPage path="/marketplace" />
        <Manage path="/manage" />
        <ViewItem path="/ViewItem/:tokenId" />
        <ManageRecord path="/ManageRecord/:tokenId" />
        <LicenseDetails path="/LicenseDetails/:licenseTokenId" />
        <Wallet path="/wallet" />
        <Create path="/create" />
        <Decode path="/decode" />
        <Attestation path="/attestation" />
        <Contact path="/contact" />
        <Uploader path="/uploader" />
      </ScrollTop>
    </PosedRouter>
    <ScrollToTopBtn />
  </div>
);
export default app;
